import {
  GET_JOBS_DATA,
  GET_JOBS_DATA_SUCCESS,
  GET_JOBS_DATA_FAIL,
  ADD_NEW_JOB,
  ADD_JOB_SUCCESS,
  ADD_JOB_FAIL,
  DELETE_JOB,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_FAIL,
  UPDATE_JOB,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAIL,
  GET_JOB_STATUS_DATA,
  GET_JOB_STATUS_DATA_SUCCESS,
  GET_JOB_STATUS_DATA_FAIL,
  ADD_NEW_JOB_STATUS,
  ADD_JOB_STATUS_SUCCESS,
  ADD_JOB_STATUS_FAIL,
  DELETE_JOB_STATUS,
  DELETE_JOB_STATUS_SUCCESS,
  DELETE_JOB_STATUS_FAIL,
  UPDATE_JOB_STATUS,
  UPDATE_JOB_STATUS_SUCCESS,
  UPDATE_JOB_STATUS_FAIL,
  GET_JOBS_PDF_DATA,
  GET_JOBS_PDF_DATA_SUCCESS,
  GET_JOBS_PDF_DATA_FAIL,
  GET_JOBS_TYPE_DATA,
  GET_JOBS_TYPE_DATA_SUCCESS,
  GET_JOBS_TYPE_DATA_FAIL,
  GET_JOBS_PRIORITY_DATA,
  GET_JOBS_PRIORITY_DATA_SUCCESS,
  GET_JOBS_PRIORITY_DATA_FAIL,
  GET_SINGLE_CUSTOMER_JOBS_LIST_DATA,
  GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_FAIL,
  GET_UNINVOICED_JOBS_LIST_DATA,
  GET_UNINVOICED_JOBS_LIST_DATA_SUCCESS,
  GET_UNINVOICED_JOBS_LIST_DATA_FAIL,
  CONVERT_JOB_TO_INVOICE,
  CONVERT_JOB_TO_INVOICE_SUCCESS,
  CONVERT_JOB_TO_INVOICE_FAIL,
  GET_RECURRING_JOBS_LIST_DATA,
  GET_RECURRING_JOBS_LIST_DATA_SUCCESS,
  GET_RECURRING_JOBS_LIST_DATA_FAIL,
  CREATE_RECURRING_JOB,
  CREATE_RECURRING_JOB_SUCCESS,
  CREATE_RECURRING_JOB_FAIL,
  GET_RECURRING_JOB_DETAILS,
  GET_RECURRING_JOB_DETAILS_SUCCESS,
  GET_RECURRING_JOB_DETAILS_FAIL,
  UPDATE_RECURRING_JOB,
  UPDATE_RECURRING_JOB_SUCCESS,
  UPDATE_RECURRING_JOB_FAIL,
  UPLOAD_JOB_FILES,
  UPLOAD_JOB_FILES_SUCCESS,
  UPLOAD_JOB_FILES_FAIL,
  SEARCH_SINGLE_JOB_FILES_LIST,
  SEARCH_SINGLE_JOB_FILES_LIST_SUCCESS,
  SEARCH_SINGLE_JOB_FILES_LIST_FAIL,
  ADD_JOB_TYPE,
  ADD_JOB_TYPE_SUCCESS,
  ADD_JOB_TYPE_FAIL,
  UPDATE_JOB_TYPE,
  UPDATE_JOB_TYPE_SUCCESS,
  UPDATE_JOB_TYPE_FAIL,
  DELETE_JOB_TYPE,
  DELETE_JOB_TYPE_SUCCESS,
  DELETE_JOB_TYPE_FAIL,
  ADD_JOB_PRIORITY,
  ADD_JOB_PRIORITY_SUCCESS,
  ADD_JOB_PRIORITY_FAIL,
  UPDATE_JOB_PRIORITY,
  UPDATE_JOB_PRIORITY_SUCCESS,
  UPDATE_JOB_PRIORITY_FAIL,
  DELETE_JOB_PRIORITY,
  DELETE_JOB_PRIORITY_SUCCESS,
  DELETE_JOB_PRIORITY_FAIL,
  DELETE_SINGLE_JOB_FILE,
  DELETE_SINGLE_JOB_FILE_SUCCESS,
  DELETE_SINGLE_JOB_FILE_FAIL,
  UPDATE_FILE_ATTACHMENT,
  UPDATE_FILE_ATTACHMENT_SUCCESS,
  UPDATE_FILE_ATTACHMENT_FAIL,
  GET_JOB_SEARCH_LIST_DATA,
  GET_JOB_SEARCH_LIST_DATA_SUCCESS,
  GET_JOB_SEARCH_LIST_DATA_FAIL,
  GET_JOBS_OPEN_LIST_DATA,
  GET_JOBS_OPEN_LIST_DATA_SUCCESS,
  GET_JOBS_OPEN_LIST_DATA_FAIL,
  GET_READY_TO_INVOICE_JOBS_LIST_DATA,
  GET_READY_TO_INVOICE_JOBS_LIST_DATA_SUCCESS,
  GET_READY_TO_INVOICE_JOBS_LIST_DATA_FAIL,
  MARK_JOB_AS_COMPLETED,
  MARK_JOB_AS_COMPLETED_SUCCESS,
  MARK_JOB_AS_COMPLETED_FAIL,
  CONVERT_JOB_TO_PROFORMA_INVOICE,
  CONVERT_JOB_TO_PROFORMA_INVOICE_SUCCESS,
  CONVERT_JOB_TO_PROFORMA_INVOICE_FAIL,
  GET_INVOICES_BY_JOB,
  GET_INVOICES_BY_JOB_SUCCESS,
  GET_INVOICES_BY_JOB_FAIL,
  PREDICTED_MARK_BILLED,
  PREDICTED_MARK_BILLED_SUCCESS,
  PREDICTED_MARK_BILLED_FAIL,
  PREDICTED_LINK_TO_INVOICEITEM,
  PREDICTED_LINK_TO_INVOICEITEM_SUCCESS,
  PREDICTED_LINK_TO_INVOICEITEM_FAIL,
} from "./actionTypes";
// ***** Jobs List CRUD Action Creators *****
//Get Jobs List
export const getJobsData = () => ({
  type: GET_JOBS_DATA,
});
// jobs data success
export const getJobsDataSuccess = (data) => ({
  type: GET_JOBS_DATA_SUCCESS,
  payload: data,
});
// jobs data fail
export const getJobsDataFail = (error) => ({
  type: GET_JOBS_DATA_FAIL,
  payload: error,
});
// create new job
export const addNewJob = (job) => ({
  type: ADD_NEW_JOB,
  payload: job,
});
// add new job success
export const addJobSuccess = (job) => ({
  type: ADD_JOB_SUCCESS,
  payload: job,
});
// add new job fail
export const addJobFail = (error) => ({
  type: ADD_JOB_FAIL,
  payload: error,
});
// delete job
export const deleteJob = (job) => ({
  type: DELETE_JOB,
  payload: job,
});
// delete job success
export const deleteJobSuccess = (job) => ({
  type: DELETE_JOB_SUCCESS,
  payload: job,
});
// delete job fail
export const deleteJobFail = (error) => ({
  type: DELETE_JOB_FAIL,
  payload: error,
});
// update job
export const updateJob = (job) => ({
  type: UPDATE_JOB,
  payload: job,
});
// update job success
export const updateJobSuccess = (job) => ({
  type: UPDATE_JOB_SUCCESS,
  payload: job,
});
// update job fail
export const updateJobFail = (error) => ({
  type: UPDATE_JOB_FAIL,
  payload: error,
});

// ***** Jobs Status Action Creators *****
//Get Jobs Status List
export const getJobStatusData = () => ({
  type: GET_JOB_STATUS_DATA,
});
// jobs status data success
export const getJobStatusDataSuccess = (data) => ({
  type: GET_JOB_STATUS_DATA_SUCCESS,
  payload: data,
});
// jobs status data fail
export const getJobStatusDataFail = (error) => ({
  type: GET_JOB_STATUS_DATA_FAIL,
  payload: error,
});
// create new job status
export const addNewJobStatus = (jobStatus) => ({
  type: ADD_NEW_JOB_STATUS,
  payload: jobStatus,
});
// add new job status success
export const addJobStatusSuccess = (jobStatus) => ({
  type: ADD_JOB_STATUS_SUCCESS,
  payload: jobStatus,
});
// add new job status fail
export const addJobStatusFail = (error) => ({
  type: ADD_JOB_STATUS_FAIL,
  payload: error,
});
// delete job status
export const deleteJobStatus = (jobStatus) => ({
  type: DELETE_JOB_STATUS,
  payload: jobStatus,
});
// delete job status success
export const deleteJobStatusSuccess = (jobStatus) => ({
  type: DELETE_JOB_STATUS_SUCCESS,
  payload: jobStatus,
});
// delete job status fail
export const deleteJobStatusFail = (error) => ({
  type: DELETE_JOB_STATUS_FAIL,
  payload: error,
});
// update job status
export const updateJobStatus = (jobStatus) => ({
  type: UPDATE_JOB_STATUS,
  payload: jobStatus,
}); // update job status success

export const updateJobStatusSuccess = (jobStatus) => ({
  type: UPDATE_JOB_STATUS_SUCCESS,
  payload: jobStatus,
});
// update job status fail
export const updateJobStatusFail = (error) => ({
  type: UPDATE_JOB_STATUS_FAIL,
  payload: error,
});

// ***** Jobs PDF Action Creators *****
//Get Jobs PDF List
export const getJobsPDFData = (job) => ({
  type: GET_JOBS_PDF_DATA,
  payload: job,
});
// jobs PDF data success
export const getJobsPDFDataSuccess = (data) => ({
  type: GET_JOBS_PDF_DATA_SUCCESS,
  payload: data,
});

// jobs PDF data fail
export const getJobsPDFDataFail = (error) => ({
  type: GET_JOBS_PDF_DATA_FAIL,
  payload: error,
});

// ***** Jobs Type Action Creators *****
//Get Jobs Type List
export const getJobsTypeData = () => ({
  type: GET_JOBS_TYPE_DATA,
});
// jobs Type data success
export const getJobsTypeDataSuccess = (data) => ({
  type: GET_JOBS_TYPE_DATA_SUCCESS,
  payload: data,
});

// jobs Type data fail
export const getJobsTypeDataFail = (error) => ({
  type: GET_JOBS_TYPE_DATA_FAIL,
  payload: error,
});

// ***** Jobs Type Action Creators *****
// Create New Job Type
export const addNewJobType = (jobType) => ({
  type: ADD_JOB_TYPE,
  payload: jobType,
});

// Create New Job Type Success
export const addJobTypeSuccess = (jobType) => ({
  type: ADD_JOB_TYPE_SUCCESS,
  payload: jobType,
});

// Create New Job Type Fail
export const addJobTypeFail = (error) => ({
  type: ADD_JOB_TYPE_FAIL,
  payload: error,
});

// Delete Job Type
export const deleteJobType = (jobType) => ({
  type: DELETE_JOB_TYPE,
  payload: jobType,
});

// Delete Job Type Success
export const deleteJobTypeSuccess = (jobType) => ({
  type: DELETE_JOB_TYPE_SUCCESS,
  payload: jobType,
});

// Delete Job Type Fail
export const deleteJobTypeFail = (error) => ({
  type: DELETE_JOB_TYPE_FAIL,
  payload: error,
});

// Update Job Type
export const updateJobType = (jobType) => ({
  type: UPDATE_JOB_TYPE,
  payload: jobType,
});

// Update Job Type Success
export const updateJobTypeSuccess = (jobType) => ({
  type: UPDATE_JOB_TYPE_SUCCESS,
  payload: jobType,
});

// Update Job Type Fail
export const updateJobTypeFail = (error) => ({
  type: UPDATE_JOB_TYPE_FAIL,
  payload: error,
});

// ***** Jobs Priority Action Creators *****
//Get Jobs Priority List
export const getJobsPriorityData = () => ({
  type: GET_JOBS_PRIORITY_DATA,
});

// jobs Priority data success
export const getJobsPriorityDataSuccess = (data) => ({
  type: GET_JOBS_PRIORITY_DATA_SUCCESS,
  payload: data,
});

// jobs Priority data fail
export const getJobsPriorityDataFail = (error) => ({
  type: GET_JOBS_PRIORITY_DATA_FAIL,
  payload: error,
});

// Create New Job Priority
export const addNewJobPriority = (jobPriority) => ({
  type: ADD_JOB_PRIORITY,
  payload: jobPriority,
});

// Create New Job Priority Success
export const addJobPrioritySuccess = (jobPriority) => ({
  type: ADD_JOB_PRIORITY_SUCCESS,
  payload: jobPriority,
});

// Create New Job Priority Fail
export const addJobPriorityFail = (error) => ({
  type: ADD_JOB_PRIORITY_FAIL,
  payload: error,
});

// Delete Job Priority
export const deleteJobPriority = (jobPriority) => ({
  type: DELETE_JOB_PRIORITY,
  payload: jobPriority,
});

// Delete Job Priority Success
export const deleteJobPrioritySuccess = (jobPriority) => ({
  type: DELETE_JOB_PRIORITY_SUCCESS,
  payload: jobPriority,
});

// Delete Job Priority Fail
export const deleteJobPriorityFail = (error) => ({
  type: DELETE_JOB_PRIORITY_FAIL,
  payload: error,
});

// Update Job Priority
export const updateJobPriority = (jobPriority) => ({
  type: UPDATE_JOB_PRIORITY,
  payload: jobPriority,
});

export const updateJobPrioritySuccess = (jobPriority) => ({
  type: UPDATE_JOB_PRIORITY_SUCCESS,
  payload: jobPriority,
});

export const updateJobPriorityFail = (error) => ({
  type: UPDATE_JOB_PRIORITY_FAIL,
  payload: error,
});

// ***** Single Customer Jobs List Action Creators *****

//Get Single Customer Jobs List
export const getSingleCustomerJobsList = (customer) => ({
  type: GET_SINGLE_CUSTOMER_JOBS_LIST_DATA,
  payload: customer,
});

// Single Customer jobs data success

export const getSingleCustomerJobsListSuccess = (data) => ({
  type: GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_SUCCESS,
  payload: data,
});

// Single Customer jobs data fail

export const getSingleCustomerJobsListFail = (error) => ({
  type: GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_FAIL,
  payload: error,
});

// ***** Uninvoiced Jobs List Action Creators *****

//Get Uninvoiced Jobs List
export const getUninvoicedJobsList = () => ({
  type: GET_UNINVOICED_JOBS_LIST_DATA,
});

// Uninvoiced jobs data success

export const getUninvoicedJobsListSuccess = (data) => ({
  type: GET_UNINVOICED_JOBS_LIST_DATA_SUCCESS,
  payload: data,
});

// Uninvoiced jobs data fail

export const getUninvoicedJobsListFail = (error) => ({
  type: GET_UNINVOICED_JOBS_LIST_DATA_FAIL,
  payload: error,
});

// Job Convert to Invoice
export const convertJobToInvoice = (job) => ({
  type: CONVERT_JOB_TO_INVOICE,
  payload: job,
});

// Job Convert to Invoice Success
export const convertJobToInvoiceSuccess = (job) => ({
  type: CONVERT_JOB_TO_INVOICE_SUCCESS,
  payload: job,
});

// Job Convert to Invoice Fail
export const convertJobToInvoiceFail = (error) => ({
  type: CONVERT_JOB_TO_INVOICE_FAIL,
  payload: error,
});

// Get Recurring Jobs List
export const getRecurringJobsList = () => ({
  type: GET_RECURRING_JOBS_LIST_DATA,
});

// Recurring jobs data success

export const getRecurringJobsListSuccess = (data) => ({
  type: GET_RECURRING_JOBS_LIST_DATA_SUCCESS,
  payload: data,
});

// Recurring jobs data fail

export const getRecurringJobsListFail = (error) => ({
  type: GET_RECURRING_JOBS_LIST_DATA_FAIL,
  payload: error,
});

// Create Recurring Job
export const createRecurringJob = (job) => ({
  type: CREATE_RECURRING_JOB,
  payload: job,
});

// Create Recurring Job Success

export const createRecurringJobSuccess = (job) => ({
  type: CREATE_RECURRING_JOB_SUCCESS,
  payload: job,
});

// Create Recurring Job Fail

export const createRecurringJobFail = (error) => ({
  type: CREATE_RECURRING_JOB_FAIL,
  payload: error,
});

// Get Recurring Job Detail
export const getRecurringJobDetail = (job) => ({
  type: GET_RECURRING_JOB_DETAILS,
  payload: job,
});

// Get Recurring Job Detail Success
export const getRecurringJobDetailSuccess = (job) => ({
  type: GET_RECURRING_JOB_DETAILS_SUCCESS,
  payload: job,
});

// Get Recurring Job Detail Fail
export const getRecurringJobDetailFail = (error) => ({
  type: GET_RECURRING_JOB_DETAILS_FAIL,
  payload: error,
});

// Update Recurring Job

export const updateRecurringJob = (job) => ({
  type: UPDATE_RECURRING_JOB,
  payload: job,
});

// Update Recurring Job Success

export const updateRecurringJobSuccess = (job) => ({
  type: UPDATE_RECURRING_JOB_SUCCESS,
  payload: job,
});

// Update Recurring Job Fail

export const updateRecurringJobFail = (error) => ({
  type: UPDATE_RECURRING_JOB_FAIL,
  payload: error,
});

// Upload job files
export const uploadJobFiles = (job) => ({
  type: UPLOAD_JOB_FILES,
  payload: job,
});

// Upload job files success
export const uploadJobFilesSuccess = (job) => ({
  type: UPLOAD_JOB_FILES_SUCCESS,
  payload: job,
});

// Upload job files fail
export const uploadJobFilesFail = (error) => ({
  type: UPLOAD_JOB_FILES_FAIL,
  payload: error,
});

// Search Single Job Files List
export const searchSingleJobFilesList = (job) => ({
  type: SEARCH_SINGLE_JOB_FILES_LIST,
  payload: job,
});

// Search Single Job Files List Success
export const searchSingleJobFilesListSuccess = (job) => ({
  type: SEARCH_SINGLE_JOB_FILES_LIST_SUCCESS,
  payload: job,
});

// Search Single Job Files List Fail
export const searchSingleJobFilesListFail = (error) => ({
  type: SEARCH_SINGLE_JOB_FILES_LIST_FAIL,
  payload: error,
});

// Delete Single Job FIle
export const deleteSingleJobFile = (job) => ({
  type: DELETE_SINGLE_JOB_FILE,
  payload: job,
});

// Delete Single Job File Success
export const deleteSingleJobFileSuccess = (job) => ({
  type: DELETE_SINGLE_JOB_FILE_SUCCESS,
  payload: job,
});

// Delete Single Job File Fail
export const deleteSingleJobFileFail = (error) => ({
  type: DELETE_SINGLE_JOB_FILE_FAIL,
  payload: error,
});

// Update File Attachment
export const updateFileAttachment = (fileAttachment) => ({
  type: UPDATE_FILE_ATTACHMENT,
  payload: fileAttachment,
});

// Update File Attachment Success
export const updateFileAttachmentSuccess = (fileAttachment) => ({
  type: UPDATE_FILE_ATTACHMENT_SUCCESS,
  payload: fileAttachment,
});

// Update File Attachment Fail
export const updateFileAttachmentFail = (error) => ({
  type: UPDATE_FILE_ATTACHMENT_FAIL,
  payload: error,
});

//GET_JOB_SEARCH_LIST_DATA
export const getJobSearchList = (job) => ({
  type: GET_JOB_SEARCH_LIST_DATA,
  payload: job,
});

//GET_JOB_SEARCH_LIST_DATA_SUCCESS
export const getJobSearchListSuccess = (data) => ({
  type: GET_JOB_SEARCH_LIST_DATA_SUCCESS,
  payload: data,
});

//GET_JOB_SEARCH_LIST_DATA_FAIL
export const getJobSearchListFail = (error) => ({
  type: GET_JOB_SEARCH_LIST_DATA_FAIL,
  payload: error,
});

//GET_JOBS_OPEN_LIST_DATA
export const getJobsOpenList = () => ({
  type: GET_JOBS_OPEN_LIST_DATA,
});

//GET_JOBS_OPEN_LIST_DATA_SUCCESS
export const getJobsOpenListSuccess = (data) => ({
  type: GET_JOBS_OPEN_LIST_DATA_SUCCESS,
  payload: data,
});

//GET_JOBS_OPEN_LIST_DATA_FAIL
export const getJobsOpenListFail = (error) => ({
  type: GET_JOBS_OPEN_LIST_DATA_FAIL,
  payload: error,
});

//GET_READY_TO_INVOICE_JOBS_LIST_DATA
export const getReadyToInvoiceJobsList = () => ({
  type: GET_READY_TO_INVOICE_JOBS_LIST_DATA,
});

//GET_READY_TO_INVOICE_JOBS_LIST_DATA_SUCCESS
export const getReadyToInvoiceJobsListSuccess = (data) => ({
  type: GET_READY_TO_INVOICE_JOBS_LIST_DATA_SUCCESS,
  payload: data,
});

//GET_READY_TO_INVOICE_JOBS_LIST_DATA_FAIL
export const getReadyToInvoiceJobsListFail = (error) => ({
  type: GET_READY_TO_INVOICE_JOBS_LIST_DATA_FAIL,
  payload: error,
});

//MARK_JOB_AS_COMPLETED
export const markJobAsCompleted = (job) => ({
  type: MARK_JOB_AS_COMPLETED,
  payload: job,
});

//MARK_JOB_AS_COMPLETED_SUCCESS
export const markJobAsCompletedSuccess = (job) => ({
  type: MARK_JOB_AS_COMPLETED_SUCCESS,
  payload: job,
});

//MARK_JOB_AS_COMPLETED_FAIL
export const markJobAsCompletedFail = (error) => ({
  type: MARK_JOB_AS_COMPLETED_FAIL,
  payload: error,
});

// Job Convert to Proforma Invoice
export const convertJobToProformaInvoice = (job) => ({
  type: CONVERT_JOB_TO_PROFORMA_INVOICE,
  payload: job,
});

// Job Convert to Proforma Invoice Success
export const convertJobToProformaInvoiceSuccess = (job) => ({
  type: CONVERT_JOB_TO_PROFORMA_INVOICE_SUCCESS,
  payload: job,
});

// Job Convert to Proforma Invoice Fail
export const convertJobToProformaInvoiceFail = (error) => ({
  type: CONVERT_JOB_TO_PROFORMA_INVOICE_FAIL,
  payload: error,
});

// Get Invoices By Job (invoices + proformas raised against a job)
// `job` should be an object with an `id` key: { id: Job_Id }
export const getInvoicesByJob = (job) => ({
  type: GET_INVOICES_BY_JOB,
  payload: job,
});

// Get Invoices By Job Success
export const getInvoicesByJobSuccess = (data) => ({
  type: GET_INVOICES_BY_JOB_SUCCESS,
  payload: data,
});

// Get Invoices By Job Fail
export const getInvoicesByJobFail = (error) => ({
  type: GET_INVOICES_BY_JOB_FAIL,
  payload: error,
});

// Predicted billable item: mark / unmark manually billed (no invoice)
// `data` = [{ Id, Billed }] — Billed 1 = mark, 0 = unmark.
export const predictedMarkBilled = (data) => ({
  type: PREDICTED_MARK_BILLED,
  payload: data,
});

export const predictedMarkBilledSuccess = (data) => ({
  type: PREDICTED_MARK_BILLED_SUCCESS,
  payload: data,
});

export const predictedMarkBilledFail = (error) => ({
  type: PREDICTED_MARK_BILLED_FAIL,
  payload: error,
});

// Predicted billable item: link to an existing invoice line item
// `data` = { JobPredictedBillableItem_Id, InvoiceItem_Id }
export const predictedLinkToInvoiceItem = (data) => ({
  type: PREDICTED_LINK_TO_INVOICEITEM,
  payload: data,
});

export const predictedLinkToInvoiceItemSuccess = (data) => ({
  type: PREDICTED_LINK_TO_INVOICEITEM_SUCCESS,
  payload: data,
});

export const predictedLinkToInvoiceItemFail = (error) => ({
  type: PREDICTED_LINK_TO_INVOICEITEM_FAIL,
  payload: error,
});
